//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheImage from "@/components/objects/TheImage.vue";
import ColorChoice from "@/components/objects/choices/ColorChoice.vue";
import { BG_SELECT_VALUES, STORAGE_BACKGROUND_PATH } from "@/constants/ui.js";
import { ASPECT_RATIO } from "@/constants/ui.js";

export default {
  name: "BackgroundChoice",

  components: { TheImage, ColorChoice },

  props: {
    type: {
      type: String,
      default: 'none'
    },
    color: {
      type: [String, null],
      default: null
    },
    image: {
      type: [String, null],
      default: null
    },
    bgImage: {
      // type: [String, Blob, null],
      default: null
    },
    adminPermission: {
      type: Boolean,
      default: true
    },
    centered: {
      type: Boolean,
      default: false
    },
    withoutColor: {
      type: Boolean,
      default: false
    },
    isWorkArea: {
      type: Boolean,
      default: false
    },
    generalStoreParams: {
      type: [Object, null],
      default: null
    },
    storageName: {
      type: [String, null],
      default: null
    },
  },

  data() {
    return {
      extraAspectRatio: [
        {
          label: '16:9',
          value: ASPECT_RATIO["16_9"]
        }
      ],
      bgImageChangedSinceOpen: false,
    }
  },

  computed: {
    isPermit() {
      return this.$auth?.loggedIn && this.$auth?.user?.profile?.use_own_style
    },
    options() {
      return BG_SELECT_VALUES.filter(el => {
        if (this.withoutColor) {
          if (el.value === 'color') {
            return null
          }
        }
        if (this.$auth && this.$auth.user) {
          return el;
        } else {
          if (el.value !== 'bg-image') {
            return el;
          }
        }
      })
    },
    STORAGE_BACKGROUND_PATH() {
      return `${STORAGE_BACKGROUND_PATH}{id}`
    }
  },
  methods: {
    emitRemove(field, previous, reason = 'clear') {
      this.$emit('remove', { field, previous, reason })
    },
    onInputImage(val) {
      const prev = this.image
      this.$emit('update:image', val)

      const isCleared = val === null || val === undefined
      const hadValue = prev !== null && prev !== undefined
      if (isCleared && hadValue) {
        this.emitRemove('image', prev)
      }
    },
    onFileChangeBgImage(val) {
      this.$emit('update:bg-image', val)
    },
    onInputBgImage(val) {
      const prev = this.bgImage
      this.$emit('update:bg-image', val)

      const isCleared = val === null || val === undefined
      const hadValue = prev !== null && prev !== undefined
      if (isCleared && hadValue) {
        this.emitRemove('bg-image', prev)
      }
    },
    onInputType($event) {
      if (!this.withoutColor) {
        this.$emit('update:color', null)
      }
      this.$emit('update:type', $event)
      this.$nextTick(() => {
        this.$nextTick(() => {
          if ($event === 'image') {
            this.$refs['image']?.openChoiceCollection();
          }
          if ($event === 'bg-image') {
            this.bgImageChangedSinceOpen = false
            this.$refs['bgImage']?.openChoiceCollection('upload-self-file');
          }
        });
      });
    },
    onImageInput(val) {
      this.$emit('update:image', val)
      if (val == null) {
        this.$emit('update:type', 'none')
      }
    },
    onImageUploaderClose() {
      this.$nextTick(() => {
        if (this.type === 'image' && this.image == null) {
          this.$emit('update:type', 'none')
        }
      })
    },
    onBgImageInput(val) {
      this.$emit('update:bg-image', val)
      if (val != null) {
        this.bgImageChangedSinceOpen = true
      }
      if (val == null) {
        this.$emit('update:type', 'none')
      }
    },
    onBgImageUploaderClose() {
      this.$nextTick(() => {
        if (this.bgImageChangedSinceOpen) {
          this.bgImageChangedSinceOpen = false
          return
        }
        if (this.type === 'bg-image' && this.bgImage == null) {
          this.$emit('update:type', 'none')
        }
      })
    }
  }
}
